import React, { useState, useEffect } from 'react';
import classes from './DeleteChecklist.module.css';
import { deleteChecklistAction } from '../../../../Store/actions/checklistsAction';
import { useDispatch, useSelector } from 'react-redux';
import useHandleSubmit from '../../../../Hooks/useHandleSubmit';

const DeleteChecklist = ({ toggleModal, trialID, checklist }) => {
	const dispatch = useDispatch();

	const handleCancelClick = (ev) => {
		ev.preventDefault();
		toggleModal();
	};

	const handleChecklistSubmit = () => {
		//dispatch(postStakeholderAction(formData));
		dispatch(deleteChecklistAction({ trialID, trialID, checklistID: inputs.groupId }));
		toggleModal();
	};

	const { inputs, handleInputChange, handleSubmit } = useHandleSubmit({
		callback: handleChecklistSubmit,
		initialState: {
			groupId: checklist.id
		}
	});

	return (
		<form className={classes['form']} onSubmit={handleSubmit}>
			<label className={classes['form__label']} htmlFor="addChecklist">
				Are you sure?
			</label>
			<p>
				<strong>You are deleting this entire checklist from your trial.</strong>
				<br />
				<br />
				All action items and their comments in this post will be permanently removed. This cannot be undone.
			</p>
			<div className={classes['form__buttons-container']}>
				<button
					onClick={handleCancelClick}
					className={[ classes['form__button'], classes['form__button--cancel'] ].join(' ')}
				>
					cancel
				</button>
				<button className={[ classes['form__button'], classes['form__button--cansubmit'] ].join(' ')}>
					delete
				</button>
			</div>
		</form>
	);
};

export default DeleteChecklist;
